import './MapGeosearch.css';
import { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import maplibregl from 'maplibre-gl';
import { useControl } from "react-map-gl";
import MaplibreGeocoder from '@maplibre/maplibre-gl-geocoder';
import MapMarker from "./MapMarker";

const MapGeosearch = (props) => {
	const [marker, setMarker] = useState(null);

	const geocoder = useControl(() => {
		const geocoder_api = { forwardGeocode };
		const ctrl = new MaplibreGeocoder(geocoder_api, {
			...props,
			marker: false,
			maplibregl: maplibregl,
			showResultsWhileTyping: true,
			debounceSearch: 400
		});
		ctrl.on('loading', props.onLoading);
		ctrl.on('results', props.onResults);
		ctrl.on('result', evt => {
			props.onResult(evt);

			const { result } = evt;
			const location = result && (result.center || (result.geometry && result.geometry.type === 'Point' && result.geometry.coordinates));
			if (location && props.marker) {
				setMarker(<MapMarker {...props.marker} longitude={location[0]} latitude={location[1]} />);
			} else {
				setMarker(null);
			}
		});
		ctrl.on('error', props.onError);
		return ctrl;
	}, { position: props.position });

	useEffect(() => {
		if (!props.marker) setMarker(null);
	}, [props.marker])

	return marker;
}

MapGeosearch.propTypes = {
	position: PropTypes.string,
	marker: PropTypes.bool,
	onLoading: PropTypes.func,
	onResults: PropTypes.func,
	onResult: PropTypes.func,
	onError: PropTypes.func,
}

MapGeosearch.defaultProps = {
	position: 'top-left',
	onLoading: () => { },
	onResults: () => { },
	onResult: () => { },
	onError: () => { },
}

export default MapGeosearch;

async function forwardGeocode(config) {
	const features = [];
	try {
		// Lat Lon search
		const matches = config.query.match(
			/^[ ]*(?:Lat: )?(-?\d+\.?\d*)[, ]+(?:Lng: )?(-?\d+\.?\d*)[ ]*$/i
		);

		if (matches) {
			function coordinateFeature(lng, lat) {
				return {
					center: [lng, lat],
					geometry: {
						type: 'Point',
						coordinates: [lng, lat]
					},
					place_name: 'Lat: ' + lat + ' Lng: ' + lng,
					place_type: ['coordinate'],
					properties: {},
					type: 'Feature'
				};
			}

			const coord1 = Number(matches[1]);
			const coord2 = Number(matches[2]);

			if (coord1 < -90 || coord1 > 90) {
				// must be lng, lat
				features.push(coordinateFeature(coord1, coord2));
			}

			if (coord2 < -90 || coord2 > 90) {
				// must be lat, lng
				features.push(coordinateFeature(coord2, coord1));
			}

			if (features.length === 0) {
				// else could be either lng, lat or lat, lng
				features.push(coordinateFeature(coord1, coord2));
				features.push(coordinateFeature(coord2, coord1));
			}
		}


		// Location search
		else {
			let request =
				'https://nominatim.openstreetmap.org/search?q=' +
				config.query +
				'&format=geojson&polygon_geojson=1&addressdetails=1';
			const response = await fetch(request);
			const geojson = await response.json();
			for (let feature of geojson.features) {
				let center = [
					feature.bbox[0] +
					(feature.bbox[2] - feature.bbox[0]) / 2,
					feature.bbox[1] +
					(feature.bbox[3] - feature.bbox[1]) / 2
				];
				let point = {
					type: 'Feature',
					geometry: {
						type: 'Point',
						coordinates: center
					},
					place_name: feature.properties.display_name,
					properties: feature.properties,
					text: feature.properties.display_name,
					place_type: ['place'],
					center: center
				};
				features.push(point);
			}
		}
	} catch (e) {
		console.error(`Failed to forwardGeocode with error: ${e}`);
	}

	return {
		features: features
	};
}